import { render, staticRenderFns } from "./V2DealPacksFilters.vue?vue&type=template&id=0ab776e8&scoped=true&"
import script from "./V2DealPacksFilters.vue?vue&type=script&lang=js&"
export * from "./V2DealPacksFilters.vue?vue&type=script&lang=js&"
import style0 from "./V2DealPacksFilters.vue?vue&type=style&index=0&id=0ab776e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab776e8",
  null
  
)

export default component.exports